import { ListItemText, MenuItem, Select, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeliveryTimeLetterLabel } from '../../common/utils/common.utils';

export interface DeliveryTimesSelectProps {
  value?: number | null;
  onChange: (policy: number) => void;
}
const DELIVERY_TIME_TO_CONFIRM = 999;


export default function DeliveryTimesSelect({ value, onChange }: DeliveryTimesSelectProps): React.JSX.Element {
  const { t } = useTranslation(['settings', 'common']);
  const options = useMemo((): React.JSX.Element[] => {
    const result = [];

    // integer is used to display letters like 'A pour A, A pour B, A pour C, etc.'
    for (let i = 1; i <= 7; i++) {
      result.push((
        <MenuItem value={i}>
          <ListItemText primary={t('settings:delivery_time_type', { to: getDeliveryTimeLetterLabel(i) }).concat(i === 1 ? ` (${t('common:same_day')})` : ` (${t('settings:delivery_time_day_plus', { count: i - 1 })})`)} />
        </MenuItem>
      ));
    }

    result.push((
      <MenuItem value={DELIVERY_TIME_TO_CONFIRM}>
        <ListItemText primary={t('common:to_confirm', { to: getDeliveryTimeLetterLabel(1) }).concat(' (J+X)')} />
      </MenuItem>
    ))

    return result;
  }, []);

  const renderDeliveryTimeSelect = (selected: number): React.ReactNode => {
    if (!selected) {
      return <Typography sx={{ color: 'placeholder.main' }}>{t('settings:delivery_times_placeholder')}</Typography>
    }

    if (selected === DELIVERY_TIME_TO_CONFIRM) {
      return t('common:to_confirm')
    }

    return t('settings:delivery_time_type', { to: getDeliveryTimeLetterLabel(selected) })
  }

  return (
    <Select
      fullWidth
      variant="outlined"
      onChange={(e) => onChange(e.target.value as number)}
      value={value ?? undefined}
      displayEmpty
      renderValue={renderDeliveryTimeSelect}
    >
      {options}
    </Select>
  );
}
